import { render, staticRenderFns } from "./vIngredientsDisplayNames.vue?vue&type=template&id=a3002ef2&scoped=true"
import script from "./vIngredientsDisplayNames.vue?vue&type=script&lang=ts"
export * from "./vIngredientsDisplayNames.vue?vue&type=script&lang=ts"
import style0 from "./vIngredientsDisplayNames.vue?vue&type=style&index=0&id=a3002ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3002ef2",
  null
  
)

export default component.exports